import { render, staticRenderFns } from "./ServiceCreate.vue?vue&type=template&id=01ca6bd4&"
import script from "./ServiceCreate.vue?vue&type=script&lang=js&"
export * from "./ServiceCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports